import Vue from 'vue'

import VPopover from './index.vue'
const Popover = Vue.extend(VPopover)
const tooltip = {
  bind(el, binding, vnode) {
    // const random = Math.random()
    const popper = new Popover({
      el: document.createElement('div')
    })
    document.body.style.position = 'relative' // 将body 设置相对定位
    document.body.appendChild(popper.$el) //
    el.instance = popper
    el.instance.content = binding.value.content || ''// 气泡中的文字
    // 浮层中的文字
    const Component = Vue.extend({
      template: `<div>${binding.value.content}</div>`
    })
    const instance = new Component()
    instance.$mount()

    el.instance.effect = binding.value.effect || 'dark'// 气泡中的文字
    let timer
    el.onmouseenter = () => {
      timer = setTimeout(function() {
        el.instance.visible = true
        Vue.nextTick(() => {
          el.instance.$refs['ref-popover-detail-body'].innerHTML = ''
          el.instance.$refs['ref-popover-detail-body'].appendChild(instance.$el)
          const _top1 = el.getBoundingClientRect().top // 获取元素距离 顶部位置
          const _top2 = document.body.scrollTop || document.documentElement.scrollTop // 获取滚动 高度
          const _offsetTop = _top1 + _top2 + 4 // 距离顶部高度  ui 4px 间距
          const _offsetLeft = el.getBoundingClientRect().left // 距离右边 距离
          const _offsetHeight = el.offsetHeight // 绑定元素高度
          const $popover = el.instance.$refs[`ref-popover`]
          $popover.addEventListener('mouseenter', function() {
            el.instance.visible = true
          })
          $popover.addEventListener('mouseleave', function() {
            el.instance.visible = false
          })
          $popover.style.top = `${_offsetTop + _offsetHeight}px`
          $popover.style.left = `${_offsetLeft}px`
        })
      }, 1500)
    }
    el.onmouseleave = (event) => {
      var div = el.instance.$refs[`ref-popover`]
      var x = event.clientX
      var y = event.clientY
      if (div?.offsetLeft && div?.offsetTop) {
        var divx1 = div.offsetLeft
        var divy1 = div.offsetTop - 10
        var divx2 = div.offsetLeft + div.offsetWidth
        var divy2 = div.offsetTop + div.offsetHeight + 10
        if (x > divx1 && x < divx2 && y > divy1 && y < divy2) {
          return false
        }
        clearTimeout(timer)
        el.instance.visible = false
      } else {
        clearTimeout(timer)
        el.instance.visible = false
      }
    }
  },
  update() { },
  unbind(el, binding) {
    // 解除事件监听
    el.instance && el.instance.$destroy()
  }
}
export default tooltip
